

// Pass 弹窗登录 SDK
export const PASSPORT_LOGIN_SDK = __IS_ONLINE__  
    ? 'https://passport.baidu.com/passApi/js/uni_login_wrapper.js'
    :  'https://passport.qatest.baidu.com/passApi/js/uni_login_wrapper.js';
  

export const passportConfig = (isMobile = false) => {
    const time = new Date();
    if (isMobile) {
        return !__IS_ONLINE__
            ? {
                userInfo:
                    '//wappass.qatest.baidu.com/v2/api/checkfacticity?&callback=showUserInfo',
                loginUrl:
                    '//wappass.qatest.baidu.com/?u=' +
                    encodeURIComponent(window.location.href),
                logout:
                    '//wappass.qatest.baidu.com/?logout&u=' +
                    encodeURIComponent(window.location.href),
                setting: 'http://wappass.qatest.baidu.com/center',
            }
            : {
                userInfo:
                    'https://wappass.baidu.com/v2/api/checkfacticity?&callback=showUserInfo',
                loginUrl:
                    'https://wappass.baidu.com/?u=' + encodeURIComponent(window.location.href),
                logout:
                    'https://wappass.baidu.com/?logout&u=' +
                    encodeURIComponent(window.location.href),
                setting: 'https://wappass.baidu.com/center',
            };
    } else {
        return !__IS_ONLINE__
            ? {
                userInfo:
                    '//passport.qatest.baidu.com/v2/api/checkfacticity?&callback=showUserInfo',
                loginUrl:
                    '//passport.qatest.baidu.com/?login&sms=5&u=' +
                    window.location.href,
                logout:
                    '//passport.qatest.baidu.com/?logout&u=' +
                    encodeURIComponent(window.location.href),
                setting: '//passport.qatest.baidu.com/center',
                register: `https://passport.qatest.baidu.com/v2/?reg&tt=${time}&overseas=&tpl=pp&u=` +
                    encodeURIComponent(window.location.href),
                registerv2: '/apiconsole/becomedev/register',
            }
            : {
                userInfo:
                    'https://passport.baidu.com/v2/api/checkfacticity?&callback=showUserInfo',
                loginUrl:
                    'https://passport.baidu.com/?login&sms=5&u=' +
                    window.location.href,
                logout:
                    'https://passport.baidu.com/?logout&u=' +
                    encodeURIComponent(window.location.href),
                setting: 'https://passport.baidu.com/center',
                register: `https://passport.baidu.com/v2/?reg&tt=${time}&overseas=&tpl=pp&u=` +
                    encodeURIComponent(window.location.href),
                registerv2: '/apiconsole/becomedev/register',
            };
    }
};

export const LBS_MOUDLES_SDK_URL = __IS_ONLINE__
    ? '/topicPage/pcsdk/lbs-module-sdk.min.js'
    : 'https://mapopen-website-wiki.bj.bcebos.com/cdn/lbs-module-sdk.min.js';
    // : 'https://cslcd.bcc-szzj.baidu.com/topicPage/pcsdk/lbs-module-sdk.min.js';

export const LBS_WEBSTATISTICS_URL = `/webstatistics/lbs-webstatistics-lib.min.js`;
export const AgentMaps = {
    mapya: {
        // id: 'd01776c14180609a',
        id: 'd01776c14180609a',
    }
}
